import React, { useState, useCallback, useEffect } from 'react';
import { Modal, Col, Row, Form } from 'react-bootstrap';
import { useDropzone } from 'react-dropzone'
import IcX from '../../components/Svg/IcX';
import IcFile from '../../components/Svg/IcFile';
import IcUpload from '../../components/Svg/IcUpload';
import { FaSpinner } from 'react-icons/fa';
import styleButton from '../Button/Button.module.css'
import styles from './style.module.css';
import Slct from '../Slct';
import FileUpload from '../FileUpload';
import useWrapper from '../../hooks/useWrapper';

const ModalUpload = props => {
  const { title, pretext, show, closeModal, uploadCB, loading, commercial_file = false, filePermission = "publico", setfilePermission, customOptions, multiple = false } = props;

  const { me } = useWrapper();
  const [upload, setUpload] = useState([])
  const onDrop = useCallback(files => {
    // Do something with the files
    setUpload(prev => (multiple ? prev : []).concat(files.map(e => Object.assign(e, {
      preview: URL.createObjectURL(e)
    }))))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [multiple])
  const { getRootProps, getInputProps } = useDropzone({
    accept: 'image/*, text/plain, .pdf, .csv, .xls, .xlsx', //
    multiple,
    useFsAccessApi: false,
    maxFilesize: 20971520, // 20 MB
    onDrop,
  })

  useEffect(() => {
    setUpload([])
  }, [title])

  return (
    <Modal size="md" show={show} onHide={loading ? () => { } : closeModal} centered>
      <Form>
        <Modal.Header>
          <div as="label" className="d-flex w-100">
            <h2 className="page-title">{title}</h2>
          </div>
          {!loading && (
            <button type="button" className={styles.closeModal} onClick={loading ? () => { } : closeModal}>
              <IcX />
            </button>
          )}
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col>
              <p>{pretext}</p>
            </Col>
          </Row>
          <div {...getRootProps()} className={`text-center ${styles.addTarefa}`}>
            <input {...getInputProps()} />
            {(!upload[0] && title) ? (
              <Row>
                <Col>
                  <div className='text-center'>
                    <p>
                      <IcUpload />
                    </p>
                    <p className='small-label'>Clique aqui ou arraste e solte {multiple ? "um ou mais arquivos" : "um arquivo"} para anexar</p>
                  </div>
                </Col>
              </Row>
            ) : multiple ? (
              <Row>
                <Col>
                  <div className='text-center'>
                    <p>
                      <IcUpload />
                    </p>
                    <p className='small-label'>Clique aqui ou arraste e solte para adicionar mais arquivos</p>
                  </div>
                </Col>
              </Row>
            ) : (
              <Row>
                <Col>
                  <div className={styles.filePreview}>
                    {upload[0] && upload[0].type.includes("image/") ? (
                      <img src={upload[0].preview} alt="Preview de Imagem" />
                    ) : (
                      !!title && (
                        <IcFile />
                      )
                    )
                    }
                    <p className='small-label'>{upload[0] && upload[0].name}</p>
                  </div>
                </Col>
              </Row>
            )}
          </div>
          {multiple && upload.length > 0 && (
            <Row className="mt-3">
              <Col>
                <FileUpload files={upload} setfiles={setUpload} loading={loading} hideButton stacked />
              </Col>
            </Row>
          )}
        </Modal.Body>

        <Modal.Footer>
          <div className="w-100 d-flex justify-content-between">
            {loading ? (
              <div className="d-flex flex-grow-1">
                Enviando Arquivo...
              </div>
            ) : (
              <>
                <div className="d-flex flex-grow-1">
                  {(commercial_file && title !== "Anexar Contrato") && (
                    <Slct
                      placeholder="..."
                      className="w-100 mr-4"
                      value={filePermission}
                      options={
                        customOptions || [
                          ...(me?.type === "Gestor" ? [
                            { label: "Apenas Gestor", value: "empresa" },
                          ] : []),
                          { label: "Arquivo Público", value: "publico" },
                          { label: "Apenas Comissão", value: "comissao" }
                        ]
                      }
                      onChange={ev => {
                        setfilePermission(ev.value);
                      }}
                    />
                  )}
                </div>
              </>
            )}

            <div>
              {!loading && <button type="button" onClick={loading ? () => { } : closeModal} className={styleButton.button_ghost}>Cancelar</button>}
              <button type="button" className={`ml-2 ${styleButton.button_primary}`} onClick={
                () => {
                  uploadCB(multiple ? upload : upload[0]);
                }
              } disabled={loading || !upload[0]}>
                {loading ? (
                  <FaSpinner color="#fff" className={styles._loading} />
                ) : (
                  <span>Enviar</span>
                )}
              </button>
            </div>
          </div>
        </Modal.Footer>
      </Form>
    </Modal>
  )
}

export default ModalUpload 